import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Grid, Box, isWidthUp, withWidth, withStyles } from "@material-ui/core";
import styled from 'styled-components';
import DynamicElement from 'shared/components/DynamicElement'

const styles = theme => ({
  wrapper: {
    minHeight: "60vh",
    backgroundColor: "#121416",
    backgroundImage: 'url(/images/Group-7352.png)',
  },
  inner: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(4)
    },
    maxWidth: 1280,
    width: "100%"
  },
});

const DiamondSingleIcon = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="86.998" height="245.043" viewBox="0 0 86.998 245.043">
  <path fill="none" stroke="#b08f6e" d="M510.847 146.634l-21.9 110.988-20.659 11.478 20.67 11.49 21.8 110.89 21.889-110.947 20.58-11.432-20.557-11.415z" transform="translate(-467.258 -146.537)" />
</svg>;

const SectionHeader = styled.h1`
  font-family: MinionPro-Disp;
  font-size: 100px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #484f57;
  margin-top: 0;
  margin-bottom: 20px;
`;

const SectionDescription = styled.div`
  width: 426px;
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.88;
  letter-spacing: normal;
  text-align: left;
  color: #b6b8bc;
  margin-bottom: 60px;
`;

const SectionButton = styled(props => <div {...props}>
  <DynamicElement id="605544c61439ae380df140c2">
    {({ value }) => <img src={value} alt="" />}
  </DynamicElement>
</div>)`
img{
  
}
`;

class Jewellery extends PureComponent {
  componentDidMount() {
    document.location.href = 'https://jewellery.henigdiamonds.co.uk/';

    const { selectJewellery = () => { } } = this.props;
    selectJewellery();
  }

  render() {
    const { classes } = this.props;
    return (
      <Box
        display="flex"
        justifyContent="center"
        className={classNames(classes.wrapper, "lg-p-top")}
      >
        <div className={classes.inner}>

          <Box padding={10}>
            <Grid container spacing={10}>
              <Grid item xs>
                <Box position="relative" align="right" paddingBottom={12} marginBottom={7}>
                  <div style={{
                    position: 'absolute',
                    top: -30,
                    left: 150,
                  }}>
                    <DynamicElement id="5ff7a9c6abbee9b8a71decef">
                      {({ value }) => <img src={value} style={{
                        width: 148,
                        height: 176,
                        objectFit: 'cover',
                      }} />}
                    </DynamicElement>
                  </div>



                  <div style={{
                    margin: '0 auto',
                    zIndex: 1,
                    position: 'relative',
                    marginTop: 40
                  }}>
                    <DynamicElement id="5ff7aa8eabbee9b8a71decf0">
                      {({ value }) => <img src={value} style={{
                        width: 255,
                        height: 300,
                        objectFit: 'cover',
                      }} />}
                    </DynamicElement>
                  </div>


                  <div style={{
                    position: 'absolute',
                    left: 190,
                    bottom: 20,
                  }}>
                    <DynamicElement id="5ff7aac9abbee9b8a71decf1">
                      {({ value }) => <img src={value} style={{
                        width: 109,
                        height: 130,
                        objectFit: 'cover',
                      }} />}
                    </DynamicElement>
                  </div>


                  <DiamondSingleIcon style={{
                    width: 27,
                    height: 77,
                    position: 'absolute',
                    right: 91,
                    top: -20,
                  }} />

                  <DiamondSingleIcon style={{
                    width: 48,
                    height: 140,
                    position: 'absolute',
                    left: 120,
                    bottom: 95,
                  }} />

                </Box>
              </Grid>
              <Grid item xs>

                <SectionHeader>
                  <DynamicElement id="5ff7ab04abbee9b8a71decf2">
                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                  </DynamicElement>
                </SectionHeader>

                <SectionDescription>
                  <DynamicElement id="5ff7ab1aabbee9b8a71decf3">
                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                  </DynamicElement>
                </SectionDescription>

                <SectionButton />
              </Grid>
            </Grid>
          </Box>


        </div>
      </Box>
    );
  }
}

Jewellery.propTypes = {
  selectJewellery: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  width: PropTypes.string.isRequired,
  jewelleryList: PropTypes.arrayOf(PropTypes.object)
};

export default withWidth()(withStyles(styles, { withTheme: true })(Jewellery));
